import React, { memo, useEffect, useState } from 'react';
import { Flex, Box } from '@chakra-ui/layout';
import { menuItems } from 'constants/sidebar';
import { checkPermission } from 'utils/authentication';
import useEventBus from 'hooks/useEventBus';

import logo from 'assets/images/daniel-logo.png';
import { useHistory } from 'react-router';

import Link from './Link';
import { getLoggedUser } from 'utils/storage';
interface IProps {}

const SideBarComponent: React.FC<IProps> = () => {
  const history = useHistory();
  const [actualPath, setActualPath] = useState(history.location.pathname);

  useEffect(() => {
    const removeListener = history.listen(e => {
      setActualPath(e.pathname);
    });

    return () => {
      removeListener();
    };
  }, []);

  const eventBus = useEventBus();
  return (
    <Box
      display="flex"
      flexDirection="column"
      mt="0"
      w="240px"
      h="100vh"
      boxShadow="5px 0px 15px rgba(0, 0, 0, 0.1)"
      color="#fff"
    >
      <Flex
        align="center"
        pt="5"
        pb="2"
        pl="5"
        pr="5"
        mx="4"
        ml="0"
        mr="0"
        mb="1"
        borderRadius="0"
        role="group"
        cursor="arrow"
      >
        <Flex w="100%" alignItems="center" justifyContent="center" mt="16px" mb="50px">
          <Box alignSelf="center" as="img" width="112px" src={logo} />
        </Flex>
      </Flex>
      <Flex alignItems="center" justifyContent="space-between" direction="column" w="100%" flex={1}>
        <Flex alignItems="center" flex={1} direction="column" w="100%">
          {menuItems
            .filter(i => !i.isLast)
            .filter(i => (!i.noParticipant ? true : !getLoggedUser().isParticipant))
            .map(item => (
              <Link
                isActivated={!!item.path.match(actualPath)}
                key={item.path}
                href={item.path}
                onClick={(e: any) => {
                  if (item.path === 'pdf') {
                    e.preventDefault();
                    eventBus.dispatchEvent('showPdfModal');
                  }
                }}
                hidden={
                  !!item.userType &&
                  !checkPermission({
                    onlyClient: item.userType === 'client',
                    onlyAdmin: item.userType === 'admin',
                  })
                }
                iconName={item.iconName}
                label={item.label}
                noSphere={!!item.path.match(actualPath)}
                aIconName={item.aIconName}
              />
            ))}
        </Flex>
        <Flex alignItems="center" direction="column" w="100%">
          {menuItems
            .filter(i => !!i.isLast)
            .filter(i => (!i.noParticipant ? true : !getLoggedUser().isParticipant))
            .map(item => (
              <Link
                isActivated={!!item.path.match(actualPath)}
                key={item.path}
                href={item.path}
                onClick={(e: any) => {
                  if (item.path === 'pdf') {
                    e.preventDefault();
                    eventBus.dispatchEvent('showPdfModal');
                  }
                }}
                hidden={
                  !!item.userType &&
                  !checkPermission({
                    onlyClient: item.userType === 'client',
                    onlyAdmin: item.userType === 'admin',
                  })
                }
                noSphere
                iconName={item.iconName}
                aIconName={item.aIconName}
                label={item.label}
              />
            ))}
        </Flex>
      </Flex>
    </Box>
  );
};

export const Sidebar = memo(SideBarComponent);
